<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li> -->
            </ol>
          </div>
          <h4 class="page-title">Role Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Roles</h4>
          <p class="sub-header">
            Create new roles for your current participant
          </p>

          <div class="row">

            <div class="col-12">
              <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" *ngIf="canAdd" (click)="addRole()"> <i class="mdi mdi mdi-key-plus"></i> </button>
            </div>

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                <thead>
                <tr>
                  <th>Role</th>
                  <th>Description</th>
                  <th *ngIf="canEdit" class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let roleAndPermissions of rolesAndPermissions">
                  <td>{{ roleAndPermissions.role.name }}</td>
                  <td>{{ roleAndPermissions.role.description }}</td>
                  <td>
                    <button type="button" *ngIf="canEdit" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="editRole(roleAndPermissions)">
                      <i class="mdi mdi-pencil-box-outline"></i>
                      Edit
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
